export const CHANGE_SCHOOL_TERM_LIST = 'CHANGE_SCHOOL_TERM_LIST';

export default function changeSchoolTermList(list) {
  return {
    type: CHANGE_SCHOOL_TERM_LIST,
    payload: {
      list,
    },
  };
}
